export const archivedNavigationPromotions = [
  { kind: 'blockwords', label: 'Block Words', href: 'https://blockwords.app' },
  { kind: 'radio', label: 'One Life Left', href: 'https://www.onelifeleft.com' },
  { kind: 'luge', label: 'LUGE', href: 'https://www.onelifeleft.com/LUGE' },
  { kind: 'microphone', label: 'Maraoke', href: 'https://maraoke.com' },
  { kind: 'skyscraper', label: 'Stackword', href: 'https://reddit.com/r/stackword' },
  { kind: 'honeypot', label: 'Honeyfy', href: 'https://honeyfy.me' },
] as const;

export const navigationPromotions = [{
  kind: 'discord',
  label: 'Discord',
  href: 'https://discord.gg/BXSzmWeBqn',
}] as const;

export type NavigationPromotion = typeof navigationPromotions[number];

export function navigationPromotionFor(): NavigationPromotion {
  return navigationPromotions[0];
}
